import { Loader } from 'lucide-react'
import { twMerge } from 'tailwind-merge';

interface LoadingSpinnerProps {
  className?: string;
  color?: string;
  size?: number | string;
}

function LoadingSpinner({ className, color, size }: LoadingSpinnerProps) {
  return <Loader size={size || 16} className={twMerge("animate-spin", className)} color={color || "white"} />
}

export default LoadingSpinner